// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchHoraires ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/horaires`)
      .then(({ data }) => {
        commit('addHoraires', data)
      })
  },
  createHoraire ({ commit }, horaire) {
    return post('/canal/horaires', horaire)
      .then(({ data }) => {
        commit('addHoraire', data)
      })
  },
  updateHoraire ({ commit }, horaire) {
    return put(`/canal/horaires/${horaire.id}`, horaire)
      .then(({ data }) => {
        commit('replaceHoraire', data)
      })
  },
  createOrUpdateHoraire ({ dispatch }, horaire) {
    if (horaire.id !== undefined) {
      return dispatch('updateHoraire', horaire)
    } else {
      return dispatch('createHoraire', horaire)
    }
  },
  selectHoraire ({ commit }, horaire) {
    commit('setHoraire', horaire)
  }
}
